/** Keep digits only (Indian mobile: up to 10 digits). */
export function normalizeIndianPhoneDigits(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 10);
}

/** Display as `987 654 3210` (no country code). */
export function formatIndianPhoneGroups(digits) {
  const d = normalizeIndianPhoneDigits(digits);
  if (!d) return "";
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)} ${d.slice(3)}`;
  return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
}

export function isValidIndianPhoneDigits(digits) {
  return normalizeIndianPhoneDigits(digits).length === 10;
}
